module.exports = __webpack_public_path__ + "img/130013.bec28290.png";